// voir les inclusions de data/chantier_data.js et data/eleve_data.js
var allConstData = const_data;
var allChantierData = chantier_data;
var allEleveData = (typeof(eleve_data) != 'undefined') ? eleve_data : [];

// import de fichiers css
import './assets/font-awesome/css/font-awesome.min.css'
import './assets/style.css'

// import depuis un module provenant de NPM - ⚠️  pas de chemin relatif
import angular from 'angular'
import 'angular-animate'
import 'angular-sanitize'
import 'angular-i18n/angular-locale_fr-fr.js'
import uiRouter from 'angular-ui-router'
import 'angularjs-datepicker'
import 'angularjs-datepicker/dist/angular-datepicker.css'
import 'ng-filedialog/ng-fileDialog.js'
import 'ng-filedialog/ng-fileDialogA.js'
import 'ng-filedialog/ng-fileDialogB.js'
import 'ng-filedialog/ng-fileDialogC.js'
import lf from 'lovefield'

require('smoothscroll-polyfill').polyfill()

// fonction spécifiques environnement off-line NodeWebkit
import { NWfunctionCheck, NWCheck, NWreadJsonFile, NWwriteJsonFile, NWgetUserDataFilePath, NWgetMacDataFilePath } from './nw/NWfunctions.js'


// ...
import { LovefieldService } from './common/db/LovefieldService.js'
import { TerrassorDB } from './common/db/TerrassorDB.js'

import {
  ApiConst,
  ApiSimu,
  ApiExo
} from './common/api/index.js'

import { HomepageComponent } from './pages/homepage/homepage.component.js'
import { SimulatorComponent } from './pages/simulator/simulator.component.js'
import { DescriptionChantierComponent } from './pages/simulator/components/description-chantier/description-chantier.component.js'
import { DescriptionMouvementComponent } from './pages/simulator/components/description-mouvement/description-mouvement.component.js'
import { SchemaEpureCreerComponent } from './pages/simulator/components/schema-epure-creer/schema-epure-creer.component.js'
import { AddEnginComponent } from './pages/simulator/components/add-engin/add-engin.component.js'
import { EditEchelonComponent } from './pages/simulator/components/edit-echelon/edit-echelon.component.js'
import { MouvementComponent } from './pages/simulator/components/mouvement/mouvement.component.js'
import { SchemaEpureComponent } from './pages/simulator/components/schema-epure/schema-epure.component.js'
import { AnimationComponent } from './pages/simulator/components/animation/animation.component.js'
import { DashboardComponent } from './pages/simulator/components/dashboard/dashboard.component.js'
import { InstallationComponent } from './pages/simulator/components/installation/installation.component.js'


import {
  HeaderComponent,
  PanelComponent,
  PanelContainerComponent,
  TabComponent,
  TabContainerComponent,
  PropertiesListComponent,
  ToggleBoxComponent,
  ModalDialogComponent,
  MessageComponent

} from './common/uiComponents/index.js'


import * as TerrassorConst from './terrassor_const.js'

// Declaration du module "app"
var terrassorApp = angular.module('app', [
  'ngAnimate',
  'ui.router',
  '720kb.datepicker', 
  'ngSanitize',
  'ng-fileDialog',
  'ng-fileDialogA',
  'ng-fileDialogB',
  'ng-fileDialogC'
], 
// pour l'environnement NW, définir le protocole chrome-extension "sûr" (ajouté aux urls par NW (en part. pour les src/images))
function($compileProvider) {
    
    $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|file|chrome-extension):|data:image\//);
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|chrome-extension):/);
})


terrassorApp.component('homepageComponent', HomepageComponent) //

terrassorApp.component('simulatorComponent', SimulatorComponent) // <simulator-component></simulator-component>

terrassorApp.component('mouvement', MouvementComponent) // <mouvement></mouvement>
terrassorApp.component('descriptionMouvement', DescriptionMouvementComponent) // <description-mouvement></description-mouvement>
terrassorApp.component('addEngin', AddEnginComponent) // <add-engin></add-engin>
terrassorApp.component('editEchelon', EditEchelonComponent) // <edit-echelon></edit-echelon>

terrassorApp.component('header', HeaderComponent) // <header></header>
terrassorApp.component('panel', PanelComponent) // <panel></panel>
terrassorApp.component('panelContainer', PanelContainerComponent) // <panel-container></panel-container>
terrassorApp.component('tab', TabComponent) // <tab></tab>
terrassorApp.component('tabs', TabContainerComponent) // <tabs></tabs>
terrassorApp.component('propertiesList', PropertiesListComponent) // <properties-list></properties-list>
terrassorApp.component('toggleBox', ToggleBoxComponent)
terrassorApp.component('modalDialog', ModalDialogComponent)
terrassorApp.component('message', MessageComponent)

terrassorApp.component('descriptionChantier', DescriptionChantierComponent) // <description-chantier></description-chantier>
terrassorApp.component('schemaEpureCreer', SchemaEpureCreerComponent)

terrassorApp.component('schemaEpure', SchemaEpureComponent)
terrassorApp.component('animation', AnimationComponent)
terrassorApp.component('dashboard', DashboardComponent)
terrassorApp.component('installation', InstallationComponent) //<installation>/<installation>


terrassorApp.service('TerrassorDB', TerrassorDB)
terrassorApp.service('ApiConst', ApiConst)
terrassorApp.service('ApiSimu', ApiSimu)
terrassorApp.service('ApiExo', ApiExo)

/*
if (!_NWCheck()) {
terrassorApp.directive('ngRightClick', function($parse) {
    return function(scope, element, attrs) {
	     var rightClickDisabled=attrs.ngRightClick;
	     if(! rightClickDisabled){
             element.bind('contextmenu', function(event) {
                 scope.$apply(function() {
                     event.preventDefault();
                 });
             });
             element.bind('keydown', function(event) {
                 scope.$apply(function() {
                     if ((event.which || event.keyCode) == 116){ // f5 keyCode
                         event.preventDefault();
                     }
                 });
             });
         }
    }
});
}
*/
terrassorApp.config(config)


LovefieldService.entreeDebug();

 //   debugger;

if (chargerWeb() == false) {
    LovefieldService.entreeDebug();
    chargerConfigurationTerrassor();
    }

function incoherenceDataEtChantierAlea(laData, chantierId, aleaId) {
    // BC : si le chantier courant (chantier_data.js) ne correspond pas à l'étude, on cherche le bon chantier dans notre base de chantiers (chantiers/chantiers_datas.js)
    // NB : on pourrait directement passer par chantiers_datas.js mais je ne veux pas reprendre tout le fonctionnement
    // surtout que, si c'est simple, je préfererais que chaque chantier reste dans un fichier autonome
    if (laData && laData.tables && laData.tables.exo_chantiers && laData.tables.exo_chantiers[0]
        && laData.tables.exo_chantiers[0].id && (laData.tables.exo_chantiers[0].id != chantierId || (laData.tables.exo_chantiers[0].alea_group_id && laData.tables.exo_chantiers[0].alea_group_id != aleaId))) {
        return(true);
    }
    return(false);
}
function coherenceDataEtChantierAlea(laData, chantierId, aleaId) {
    // BC : si le chantier courant (chantier_data.js) ne correspond pas à l'étude, on cherche le bon chantier dans notre base de chantiers (chantiers/chantiers_datas.js)
    // NB : on pourrait directement passer par chantiers_datas.js mais je ne veux pas reprendre tout le fonctionnement
    // surtout que, si c'est simple, je préfererais que chaque chantier reste dans un fichier autonome
    if (laData && laData.tables && laData.tables.exo_chantiers && laData.tables.exo_chantiers[0]
        && laData.tables.exo_chantiers[0].id && (laData.tables.exo_chantiers[0].id == chantierId && (!aleaId || laData.tables.exo_chantiers[0].alea_group_id == aleaId))) {
        console.log('coherenceDataEtChantierAlea true')
        return(true);
    }
    console.log('coherenceDataEtChantierAlea false')
    return(false);
}


function chargerConfigurationTerrassor() {


    /*
    * BC 2019/02 : il est ici possible que la BD ne soit pas vide : on peut avoir un intérêt à conserver sa partie étude
    * --> todo
    * --> pour le moment, on repart systématiquement de 0
    */





    console.log('chargerConfigurationTerrassor')

    // ici on sait si on est en mode examen : allEleveData.mode (todo reste à régler le cas du "mode epure")
    if (typeof(allEleveData.mode) != 'undefined') {
        TerrassorConst.MODE_UTILISATION = allEleveData.mode;
        if (TerrassorConst.MODE_UTILISATION == TerrassorConst.MODE_EXAMEN) {
            TerrassorConst.DATABASE_NAME += "X";
        }
    }

    // si nécessaire init / update de la DB
    //var etudeId = this.$location.search.etudeId;
    // BC : si le chantier courant (chantier_data.js) ne correspond pas à l'étude, on cherche le bon chantier dans notre base de chantiers (chantiers/chantiers_datas.js)
    // NB : on pourrait directement passer par chantiers_datas.js mais je ne veux pas reprendre tout le fonctionnement
    // surtout que, si c'est simple, je préfererais que chaque chantier reste dans un fichier autonome
    if ((TerrassorConst.MODE_UTILISATION == TerrassorConst.MODE_SIMULATEUR) && (incoherenceDataEtChantierAlea(allEleveData, allChantierData.tables.exo_chantiers[0].id, allChantierData.tables.exo_chantiers[0].alea_group_id))) {
        console.log('chargerConfigurationTerrassor : lireChantierDataId ')
        lireChantierDataId(allEleveData.tables.exo_chantiers[0].id, allEleveData.tables.exo_chantiers[0].alea_group_id, allEleveData.tables.exo_chantiers[0].fichier);
    }
    else {
        console.log('chargerConfigurationTerrassor : mainLoadData ')
        mainLoadData();
    }
}

// Configuration du module "app"
function config ($stateProvider, $urlRouterProvider) {
  $urlRouterProvider.otherwise('/homepage')
  //$urlRouterProvider.otherwise('/simulator')
  // configuration du routeur, les états de l'application sont fixés par l'url
  $stateProvider
  /**/
    .state('epure', {
      url: '/epure',
      component: 'simulatorComponent'
    })
    .state('etude', {
      url: '/etude/:etudeId',
      component: 'simulatorComponent'
    })
    .state('chantier', {
      url: '/chantier/:chantierId',
      component: 'simulatorComponent'
    })
    .state('simulator', {
      url: '/simulator',
      component: 'simulatorComponent'
    })
    .state('homepage', {
      url: '/homepage',
      component: 'homepageComponent'
    })
    .state('ticket', {
      url: '/ticket/:ticketId',
      component: 'homepageComponent'
    })
}

/*
* <=> lancement de l'appli au "onload" des données DB
*/
function startAngular () {
    console.log('startAngular')
    angular.element(document).ready(function () { // on document ready
        // Noeud DOM où l'application sera lancée
        const appNode = document.querySelector('#app');

    // On définit l'endroit dans appNode où le routeur prendra le relai
    // Le routeur à besoin de l'attribut ui-view pour lui indiquer où
    // il va effectuer le rendu des pages definies dans sa configuration au dessus.
        appNode.innerHTML ='<div ui-view></div>';

    // Lancement de l'application du module 'app' sur le noeud DOM #app
        angular.bootstrap(appNode, ['app']);
    })
}

// cette fonction peut être appelée en direct ci-dessus ou via lireChantierDataId (et via un callback)
function mainLoadData() {
    console.log('mainLoadData : avant dropAllTables')

    TerrassorConst.chantierCode = TerrassorConst.CHANTIER_CODE;
    TerrassorConst.chantierId = TerrassorConst.CHANTIER_ID;
    TerrassorConst.alea_group_id = TerrassorConst.ALEA_GROUPE_ID;

    if (TerrassorConst.MODE_UTILISATION == TerrassorConst.MODE_SIMULATEUR) {
        if (allChantierData.tables) {
            TerrassorConst.chantierCode = allChantierData.tables.exo_chantiers[0].code;
            TerrassorConst.chantierId = allChantierData.tables.exo_chantiers[0].id;
            TerrassorConst.alea_group_id = allChantierData.tables.exo_chantiers[0].alea_group_id;
            }
        }
    else { // si on n'est pas en mode simulateur, on a notre chantier "virtuel" stocké dans l'étude
        console.log('mainLoadData : chantier "virtuel"')
        if (typeof(allEleveData.tables.exo_chantiers) != 'undefined') {
            console.log('mainLoadData : chantier "virtuel" load')
            TerrassorConst.chantierCode = allEleveData.tables.simuexo_chantiers[0].code;
            TerrassorConst.chantierId = allEleveData.tables.simuexo_chantiers[0].id;
            allChantierData.tables = null; // BC 2019/04 -> on ne veut pas charger le chantier !!!
            }
        }

    LovefieldService.loadData(allConstData, allChantierData, allEleveData)
            .then(startAngular) // lancement de l'app AngularJS
    /*
    // BC 2019/02 - bien noter que les données stockées en base ne sont JAMAIS réutilisées
    // todo : si la base n'est pas vide !
    if (confirm("Voulez-vous utiliser les données conservées par Terrassor ?")) {
        // on vide pas la base !
            LovefieldService.loadData(allConstData, allChantierData, allEleveData)
                .then(startAngular) // lancement de l'app AngularJS
    } else {
        // on vide la base le temps de lire les constantes // BC 2019 - test idem web
        LovefieldService.dropAllTables()
            .then(retour => {
                LovefieldService.loadData(allConstData, allChantierData, allEleveData)
                    .then(startAngular) // lancement de l'app AngularJS
        });
    }
    */
}

export default LovefieldService // voir avec RA à quoi sert cet export ...


function lireChantierDataId(id, aleaId, nomFichier) {


    var path = NWgetUserDataFilePath() + "\\data\\chantiers\\";
    var isMac = process.platform; // darwin pour mac
    if (isMac === "darwin") {
        path = "data/chantiers/";
    }
    var objRef = new Object();
    objRef.trouve = false;
    objRef.fin = 0;
    var ok=false;

    if (typeof(nomFichier) != 'undefined') {
        // on vérifie que le nom du chantier existe pour pouvoir l'utiliser
        chantiers_liste.forEach(function(fichierChantier){
            if (fichierChantier == nomFichier) {
                ok=true;
            }
        });

    }
    if (ok) {
    console.log('lireChantierDataId A : ', path+nomFichier);
         loadScript(path+nomFichier, objRef, 0, function(obj){
             var objRef = obj.currentTarget._objRef;
             var index = obj.currentTarget._index;
             if (coherenceDataEtChantierAlea(chantier_data, id, aleaId) && objRef.trouve == false) {
                objRef.trouve = true;
                allChantierData = chantier_data;
                mainLoadData();
             }
             else {
                 // si on est allé au bout sans trouver
                 if (objRef.fin == index && objRef.trouve == false) {
                     // le chantier n'est pas disponible, on garde les valeurs stockées dans l'étude
    console.log('lireChantierDataId : chantier non trouvé A', allChantierData);
                    allChantierData.tables = null; // BC 2019/04 -> on ne veut pas charger le chantier !!!
                    mainLoadData();
                 }
             }
            });
    }
    else { // il est possible que le nom du chantier (fichier) ait changé par rapport a celui stocké dans l'étude :-( dans ce cas là on cherche dans tous les fichiers dispos si un chantier a un id qui correspond
//debugger;
        objRef.fin = chantiers_liste.length-1;
        chantiers_liste.forEach(function(fichierChantier, index){
    console.log('lireChantierDataId B : ', path+nomFichier);
            loadScript(path+fichierChantier, objRef, index, function(obj){
             var objRef = obj.currentTarget._objRef;
             var index = obj.currentTarget._index;
             if (coherenceDataEtChantierAlea(chantier_data, id, aleaId) && objRef.trouve == false) {
    console.log('lireChantierDataId : coherenceDataEtChantierAlea', chantier_data);
                 objRef.trouve = true;
                 allChantierData = chantier_data;
                 mainLoadData();
             }
             else {
                 // si on est allé au bout sans trouver
                 if (objRef.fin == index && objRef.trouve == false) {
    console.log('lireChantierDataId : chantier non trouvé B', allChantierData);
                     // le chantier n'est pas disponible, on garde les valeurs stockées dans l'étude
                    allChantierData.tables = null; // BC 2019/04 -> on ne veut pas charger le chantier !!!
                    mainLoadData();
                 }
             }
            });
        });
    }

}

/* BC 2017/12 passer par un chantiers_datas.js qui comprend juste les noms des fichiers chantier
puis les ouvrir un par un dans lireChantierDataId
jusqu'à trouver celui qui correspond au bon ID
pour simplifier les manip des profs ... mettre cette liste dans const_data.js ?
*/
function loadScript(url, objRef, index, callback) {

    console.log('loadScript : ', url);
    $.get(url)
    .done(function() {
        console.log('loadScript done');
        // exists code
        loadScriptSecure(url, objRef, index, callback);
    }).fail(function() {
        console.log('loadScript fail');
        // not exists code
        url = enleverAccents(url);
        loadScriptSecure(url, objRef, index, callback);
    })
}


 /* */
function loadScriptSecure(url, objRef, index, callback) {
    console.log('loadScriptSecure : ', url);
    // Prépare l'ajoute du script au head
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    // Lance une callback à la fin de la tâche
    script.onreadystatechange = callback;
    script.onload = callback;

    // les paramètres
    script._objRef = objRef;
    script._index = index;

    // Ajoute le script
    head.appendChild(script);
}


function enleverAccents(str)
{
    str = str.replace(/À|Á|Â|Ã|Ä|Å/g,"A");
    str = str.replace(/à|á|â|ã|ä|å/g,"a");
    str = str.replace(/È|É|Ê|Ë/g,"E");
    str = str.replace(/è|é|ê|ë|ð/g,"e");
    str = str.replace(/Ì|Í|Î|Ï/g,"I");
    str = str.replace(/ì|í|î|ï/g,"i");
    str = str.replace(/Ò|Ó|Ô|Õ|Õ|Ö|Ø/g,"O");
    str = str.replace(/ò|ó|ô|õ|ö|ø/g,"o");
    str = str.replace(/Ù|Ú|Û|Ü/g,"U");
    str = str.replace(/ù|ú|û|ü/g,"u");
    str = str.replace(/Ÿ/g,"Y");
    str = str.replace(/ÿ|ý/g,"y");
    str = str.replace(/Ç/g,"C");
    str = str.replace(/ç/g,"c");
    str = str.replace(/Ð/g,"D");
    str = str.replace(/Ñ/g,"N");
    str = str.replace(/ñ/g,"n");
    str = str.replace(/Š/g,"S");
    str = str.replace(/š/g,"s");
    str = str.replace(/Ž/g,"Z");
    str = str.replace(/ž/g,"z");
    return str;
}

function nonMerciBill() {
    var is_explorer=(typeof(document !== 'undefined') && document.documentMode) || /Edge/.test(navigator.userAgent);
    var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var is_opera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    /*
    var is_chrome = !!window.chrome && !is_opera;
    var is_firefox = typeof window.InstallTrigger !== 'undefined';
    */

    /*
    if (is_safari) {

        var script1 = "https://cdn.jsdelivr.net/npm/es6-promise@4/dist/es6-promise.js";
        var script2 = "https://cdn.jsdelivr.net/npm/es6-promise@4/dist/es6-promise.auto.js";
        var objRef = new Object();
        objRef.trouve = false;
        objRef.fin = 0;

        loadScript(script1, objRef, 0, function(obj){
            var objRef = obj.currentTarget._objRef;
            var index = obj.currentTarget._index;

            loadScript(script2, objRef, 0, function(obj){
                // in est sur la version WEB
                TerrassorConst.IS_WEB = 1;
                apiAutorisation();
                });
            });

            alert('Bonjour Safari');
            return(true);
        } */
    // detect IE8 and above, and edge
    if (is_explorer || is_safari) {
        alert('Attention ! Terrassor doit être utilisé depuis les navigateurs Chrome, Firefox ou Opera ...');
        //window.location.href("http://terrassor.fr");
        document.location.href="https://terrassor.fr";
        //window.location.reload();
        return(true);
    }
    return(false);
}

function chargerWeb() {
    console.log('chargerWeb')

    if (_NWCheck()) {
        console.log('chargerWeb sortie _NWCheck')
        return(false);
    }


    if (nonMerciBill()) {
        return(true);
    }

    // in est sur la version WEB
    TerrassorConst.IS_WEB = 1;

    apiAutorisation();
    return(true);
}

function isHomepageWeb() {
    var hash = window.location.hash;
    var resultats = hash.split('homepage');
    if (resultats.length > 1) { // si accueil
        return(true);
    }
    var resultats = hash.split('#');
    if (resultats.length < 2) { // si accueil (mon.terrassor.fr tout simplement)
        return(true);
    }
    var resultats = hash.split('/ticket/');
    if (resultats.length > 1) { // si accueil
        return(true);
    }
    return(false);
}

function chargerWebAutorise() {

    console.log('chargerWebAutorise')

    TerrassorConst.DATABASE_NAME += "W"; // on travaille avec une base différente pour la version en ligne : TerrassorW et on Delete cette base au bon moment (en sortant ? en chargeant ? pb du F5 !!!)

    var etudeId = 0;
    // par défaut on charge un chantier
    var chantier_id = 2;
    var alea_group_id = 1;
    var approbation;
    var hash = window.location.hash;
    var resultats = hash.split('/etude/');
    if (resultats.length > 1) { // si etude
        etudeId = resultats[1];
    }
    else {
        resultats = hash.split('/chantier/');
        if (resultats.length > 1) { // si chantier
            var resultatsChantier = resultats[1].split('_');
            if (resultatsChantier.length > 1) { // si OK
                chantier_id = resultatsChantier[0];
                alea_group_id = resultatsChantier[1];
                approbation = resultatsChantier[2]; // undefined possible (voire probable !)
            }
        }
        else {
            resultats = hash.split('/epure');
            if (resultats.length > 1) { // si épure = chantier vide
                chantier_id = -1;
                alea_group_id = 0;
            }
        }
    }
    jQuery.ajax({
        type: "POST",
        url: "external/php/readFile.php?key="+etudeId, // on charge une étude - éventuellement vide
        dataType: 'json',
        success: function(res){
            console.log('Callback readFile');

            allEleveData = res;
            if (allEleveData.tables && allEleveData.tables.exo_chantiers && allEleveData.tables.exo_chantiers.length) {
                console.log('chargerWebAutorise : alea_group_id, id_chantier', allEleveData.tables.exo_chantiers[0].alea_group_id, allEleveData.tables.exo_chantiers[0].id);
                if ((allEleveData.tables.exo_chantiers[0].alea_group_id && allEleveData.tables.exo_chantiers[0].id) ||
                    (allEleveData.tables.exo_chantiers[0].alea_group_id == 0 && allEleveData.tables.exo_chantiers[0].id == -1)) {
                    alea_group_id = allEleveData.tables.exo_chantiers[0].alea_group_id;
                    chantier_id = allEleveData.tables.exo_chantiers[0].id;
                    TerrassorConst.codeEtude = etudeId;
                }
                else {
                    alert("Le format de l'étude est obsolète ou le fichier est corrompu. Le chargement est impossible");
                    chargerChantierId("");
                }
            }
            else {
                if (allEleveData.tables && allEleveData.tables.simuexo_chantiers && allEleveData.tables.simuexo_chantiers.length) {
                    alea_group_id = 0;
                    chantier_id = -1;
                    TerrassorConst.codeEtude = etudeId;
                }
            }
            chargerWebChantier(chantier_id, alea_group_id, approbation); // on charge le chantier (éventuellement on le choisit)
            },
        error : function(res){
            console.log('Pb Callback readFile');
            chargerWebChantier();
        }
    });


    return(true);
}

function chargerWebChantier(chantier_id, alea_group_id, approbation = '') {
    console.log('chargerWebChantier')

    if (chantier_id && alea_group_id) {
        if (approbation == 'V') {
            approbation = '/V';
        }
        jQuery.ajax({
            type: "POST",
            url: TerrassorConst.URL_ADMIN+"/api/exo-chantiers/single/"+chantier_id+"/"+alea_group_id+approbation+".json",
            dataType: 'json',
            success: function(res){
//debugger;
                console.log('Callback chargerWebChantier');
                allChantierData = res.exoChantier;
                TerrassorConst.chantierCode = allChantierData.tables.exo_chantiers[0].code;
                TerrassorConst.chantierId = allChantierData.tables.exo_chantiers[0].id;
                TerrassorConst.alea_group_id = allChantierData.tables.exo_chantiers[0].alea_group_id;
                chargerWebConstantes();
            },
            error : function(res){
                console.log('Pb Callback chargerWebChantier');
            }
        });
    }
    else {
        // si on veut creer une épure à vide
        if (chantier_id == -1) {
            jQuery.ajax({
                type: "POST",
                url: "external/php/readFile.php?key=-1", // on charge un chantier vide
                dataType: 'json',
                success: function(res){
                    console.log('Callback chargerWebChantier épure');
                    allChantierData = res;
                    TerrassorConst.chantierCode = TerrassorConst.CHANTIER_CODE;
                    TerrassorConst.chantierId = TerrassorConst.CHANTIER_ID;
                    TerrassorConst.alea_group_id = TerrassorConst.ALEA_GROUPE_ID;
                    TerrassorConst.MODE_UTILISATION = TerrassorConst.MODE_EPURE;
                    chargerWebConstantes();
                },
                error : function(res){
                    console.log('Pb Callback chargerWebChantier');
                }
            });
        }
    }
}


function chargerWebConstantes() {
    console.log('chargerWebConstantes')

        return LovefieldService.dropAllTables()// on vide la base le temps de lire les constantes
        .then(retour => {

            jQuery.ajax({
                type: "POST",
                url: "external/php/readConst.php",
                dataType: 'json',
                success: function(res){
//debugger;
                    console.log('Callback chargerWebConstantes');
                    allConstData = res;
                    LovefieldService.loadData(allConstData, allChantierData, allEleveData)
                    .then(startAngular) // lancement de l'app AngularJS
                    },
                error : function(res){
//debugger;
                    console.log('Pb Callback chargerWebConstantes');
                }
            });
        });
    }


// Gestion du code d'autorisation : Web seulement
function webAiguillageClandestins() {
    if (isHomepageWeb()) {
        TerrassorConst.SECURITE_VALIDE = 0;
        chargerWebAutorise();
        }
    else {
        alert("Vous devez saisir un code valide pour accéder à l'ensemble des fonctions de Terrassor");
        // seule page autorisée (à ne pas faire si on y est déjà !!!!! cf. juste au dessus)
        document.location.href="/#/homepage";
        window.location.reload();
        }
    }

// Gestion du code d'autorisation : Web seulement
function apiAutorisation() {
    console.log('apiAutorisation');
    //var ticket;

    var ticket = "";
    var hash = window.location.hash;
    var resultatsTicket = hash.split('/ticket/');
    if (resultatsTicket.length > 1) { // si ticket transmis
        ticket = resultatsTicket[1];
        ecrireTicketURL(ticket); // on l'écrit dans la session (sans s'occuper du retour)
        validerTicket(ticket); // puis on valide sans attendre
    }
    else {
        jQuery.ajax({
            type: "POST",
            url: "external/php/readTicket.php", // on lit, s'il existe, le ticket dans une variable de session
            dataType: 'json',
            success: function(res){
                // on demande l'autorisation via ce ticket
                if (res.ok) {
                    console.log('apiAutorisation, ticket lu : ', res.ticket);
                    // ajax qui valide le ticket
                    validerTicket(res.ticket);
                }
                else {
                    console.log('apiAutorisation, ticket lu mais pas ok : ', res.ticket);
                    webAiguillageClandestins();
                }

            },
            error : function(res){
                console.log('apiAutorisation, ticket non lu');
                webAiguillageClandestins();
            }
        });
    }
}

// Gestion du code d'autorisation : Web seulement
function validerTicket(ticket) {
    TerrassorConst.SECURITE_VALIDE = 1;
    jQuery.ajax({
        type: "POST",
        //url: "external/php/tmpValidationTicket.php?ticket="+ticket,
        url: "https://admin.terrassor.fr/api/tickets/autorisation/"+ticket+".json",
        dataType: 'json',
        success: function(res){
            if (res.retour && res.retour.ok > 0) {
                console.log('validerTicket, ticket OK : ', ticket);
                chargerWebAutorise();
            }
            else {
                console.log('validerTicket, ticket lu pas OK : ', ticket);
                if (res.retour) {
                    webAiguillageClandestins(res.retour.ok);
                }
                else {
                    webAiguillageClandestins(0);
                }
            }
        },
        error : function(res){
                console.log('validerTicket, ticket pas lu : ', ticket);
            webAiguillageClandestins();
            }
    });
}

// ecriture du ticket dans la session s'il est passé dans l'URL
 function ecrireTicketURL(ticket) {

        jQuery.ajax({
            type: "POST",
            url: "external/php/readTicket.php?ticket="+ticket, // on charge une étude - éventuellement vide
            dataType: 'json',
            success: function(res){
				    if (res.ok) {
                        // ecriture variable de session OK
                        //alert("ecrireTicket OK");
                        console.log('ecrireTicketURL, ticket écrit : ', ticket);
                    }
                    else {
                        // ecriture variable de session pas OK
                        //alert("ecrireTicket pas OK 1");
                        console.log('ecrireTicketURL, ticket pas écrit : ', ticket);
                    }

                },
            error : function(res){
                // ecriture variable de session pas OK
                //alert("ecrireTicket pas OK 2");
                        console.log('ecrireTicketURL, erreur : ', ticket);
                }
            });
        }

//ohMonBeauTicket



// WEBPACK FOOTER //
// ./src/client/main.js